import { render, staticRenderFns } from "./simpleKeyboard.vue?vue&type=template&id=13d6ea9a"
import script from "./simpleKeyboard.vue?vue&type=script&lang=js"
export * from "./simpleKeyboard.vue?vue&type=script&lang=js"
import style0 from "./simpleKeyboard.vue?vue&type=style&index=0&id=13d6ea9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports